module.exports = __webpack_public_path__ + "img/kfCode.409dccae.png";